<template>
  <header class="navbar" role="banner">
    <div class="navbar-left">
      <hamburger
        class="hamburger-container"
        :toggleClick="toggleSideBar"
        :isActive="sidebar.opened">
      </hamburger>
      <breadcrumb class="navbar-breadcrumb" />
    </div>
    <div class="navbar-right">
      <el-tooltip content="主题" placement="bottom">
        <el-button type="text" class="tool-btn" @click="toggleTheme">
          <i :class="themeIcon"></i>
        </el-button>
      </el-tooltip>
      <el-dropdown class="avatar-dropdown" trigger="click">
        <div class="avatar-wrapper">
          <img class="user-avatar" :src="avatarUrl" alt="" @error="onAvatarError">
          <i class="el-icon-caret-bottom avatar-caret"></i>
        </div>
        <el-dropdown-menu class="user-dropdown" slot="dropdown">
          <router-link class="inlineBlock" to="/">
            <el-dropdown-item>
              首页
            </el-dropdown-item>
          </router-link>
          <el-dropdown-item @click.native="openPasswordDialog">
            修改密码
          </el-dropdown-item>
          <el-dropdown-item divided>
            <span @click="logout" style="display:block;">退出</span>
          </el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown>
    </div>

    <el-dialog
      title="修改密码"
      :visible.sync="passwordDialogVisible"
      :close-on-click-modal="false"
      width="420px"
      @closed="resetPasswordForm">
      <el-form
        ref="passwordForm"
        :model="passwordForm"
        :rules="passwordRules"
        label-width="92px"
        auto-complete="off">
        <el-form-item label="旧密码" prop="oldPassword">
          <el-input v-model="passwordForm.oldPassword" type="password" auto-complete="new-password" />
        </el-form-item>
        <el-form-item label="新密码" prop="newPassword">
          <el-input
            v-model="passwordForm.newPassword"
            type="password"
            auto-complete="new-password"
            placeholder="8-64 位, 同时包含字母和数字" />
        </el-form-item>
        <el-form-item label="确认新密码" prop="confirmPassword">
          <el-input v-model="passwordForm.confirmPassword" type="password" auto-complete="new-password" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="passwordDialogVisible = false">取消</el-button>
        <el-button type="primary" :loading="passwordLoading" @click="submitPassword">提交</el-button>
      </span>
    </el-dialog>
  </header>
</template>

<script>
import { mapGetters } from 'vuex'
import Breadcrumb from '@/components/Breadcrumb'
import Hamburger from '@/components/Hamburger'
import { updateAdminPassword } from '@/api/login'

export default {
  data() {
    const validateNewPassword = (rule, value, callback) => {
      if (!value) {
        return callback(new Error('请输入新密码'))
      }
      if (value.length < 8 || value.length > 64) {
        return callback(new Error('新密码长度需在 8-64 位之间'))
      }
      if (!/^(?=.*[A-Za-z])(?=.*\d).{8,64}$/.test(value)) {
        return callback(new Error('新密码需同时包含字母和数字'))
      }
      if (value === this.passwordForm.oldPassword) {
        return callback(new Error('新密码不能与旧密码相同'))
      }
      callback()
    }
    const validateConfirm = (rule, value, callback) => {
      if (value !== this.passwordForm.newPassword) {
        return callback(new Error('两次输入的新密码不一致'))
      }
      callback()
    }
    return {
      defaultAvatar: 'data:image/svg+xml;utf8,<svg xmlns="http://www.w3.org/2000/svg" width="80" height="80"><rect width="100%" height="100%" fill="%23E5E7EB"/><text x="50%" y="54%" font-size="26" text-anchor="middle" fill="%239CA3AF">U</text></svg>',
      avatarLoadError: false,
      passwordDialogVisible: false,
      passwordLoading: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      passwordRules: {
        oldPassword: [{ required: true, trigger: 'blur', message: '请输入旧密码' }],
        newPassword: [{ required: true, trigger: 'blur', validator: validateNewPassword }],
        confirmPassword: [{ required: true, trigger: 'blur', validator: validateConfirm }]
      }
    }
  },
  components: {
    Breadcrumb,
    Hamburger
  },
  computed: {
    ...mapGetters([
      'sidebar',
      'avatar',
      'theme',
      'name'
    ]),
    avatarUrl() {
      if (this.avatarLoadError || !this.avatar) {
        return this.defaultAvatar
      }
      return this.avatar
    },
    themeIcon() {
      return this.theme === 'dark' ? 'el-icon-sunny' : 'el-icon-moon'
    }
  },
  watch: {
    avatar() {
      this.avatarLoadError = false
    }
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch('ToggleSideBar')
    },
    logout() {
      this.$store.dispatch('LogOut').then(() => {
        location.reload()
      })
    },
    toggleTheme() {
      this.$store.dispatch('ToggleTheme')
    },
    onAvatarError() {
      this.avatarLoadError = true
    },
    openPasswordDialog() {
      this.passwordDialogVisible = true
    },
    resetPasswordForm() {
      this.passwordForm.oldPassword = ''
      this.passwordForm.newPassword = ''
      this.passwordForm.confirmPassword = ''
      if (this.$refs.passwordForm) {
        this.$refs.passwordForm.clearValidate()
      }
    },
    submitPassword() {
      this.$refs.passwordForm.validate(valid => {
        if (!valid) return
        if (!this.name) {
          this.$message.error('当前未识别到登录用户, 请重新登录后再试')
          return
        }
        this.passwordLoading = true
        updateAdminPassword({
          username: this.name,
          oldPassword: this.passwordForm.oldPassword,
          newPassword: this.passwordForm.newPassword
        }).then(res => {
          this.passwordLoading = false
          if (res && res.code === 200) {
            this.$message.success('密码修改成功, 请重新登录')
            this.passwordDialogVisible = false
            setTimeout(() => {
              this.$store.dispatch('LogOut').then(() => {
                location.reload()
              })
            }, 800)
          } else {
            this.$message.error((res && res.message) || '密码修改失败')
          }
        }).catch(() => {
          this.passwordLoading = false
        })
      })
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: var(--nav-height, 50px);
  min-height: var(--nav-height, 50px);
  padding: 0 8px 0 4px;
  background: var(--bg-surface);
  /* 与 TagsView 一起作为粘性头部 (修复"上方横条空隙"bug):
     Navbar sticky 在 top:0, TagsView sticky 在 top:50px, 二者一组永远在视口顶.
     去掉 Navbar 自己的 border-bottom + box-shadow, 让 TagsView 的 border-bottom
     作为整个粘性头部的下沿 (避免双横线视觉). */
  position: sticky;
  top: 0;
  z-index: 1103;
}

.navbar-left {
  display: flex;
  align-items: center;
  min-width: 0;
  flex: 1;
}

.hamburger-container {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  height: var(--nav-height, 50px);
  padding: 0 10px;
}

.navbar-breadcrumb {
  min-width: 0;
  flex: 1;
}

.navbar-right {
  flex-shrink: 0;
  display: flex;
  align-items: center;
  gap: 4px;
  padding-right: 12px;
}

.tool-btn {
  color: var(--text-secondary);
  padding: 8px 10px;
  border-radius: 8px;
  font-weight: 500;
}

.tool-btn:hover {
  background: rgba(148, 163, 184, 0.14);
  color: var(--text-primary);
}

.avatar-dropdown {
  margin-left: 4px;
}

.avatar-wrapper {
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 4px;
  padding: 4px 6px;
  border-radius: 10px;
  transition: background 0.15s ease;
}

.avatar-wrapper:hover {
  background: rgba(148, 163, 184, 0.12);
}

.user-avatar {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: 1px solid var(--border-color);
  object-fit: cover;
}

.avatar-caret {
  font-size: 12px;
  color: var(--text-muted);
}

body.theme-dark .tool-btn:hover {
  background: rgba(148, 163, 184, 0.1);
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue